export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./referral.vue?vue&type=template&id=41f8f3b0"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/referral.vue?vue&type=template&id=41f8f3b0
// module id = ySRB
// module chunks = 0